import * as React from 'react';

export enum USAGE_CODES {
    USED = 'Used',
    NOT_USED = 'Not used',
    NOT_RECEIVED = 'Not received',
    DOES_NOT_WORK = 'Does not work',
    DAMAGED_IN_TRANSIT = 'Damaged in transit',
    WRONG_PART = 'Wrong part',
}

export const NOTE_PLACEHOLDERS = {
  [USAGE_CODES.USED]: 'What was wrong with the original part?',
  [USAGE_CODES.NOT_USED]: 'Why was the new part not used?',
  [USAGE_CODES.NOT_RECEIVED]: 'Were there any delivery issues on site?',
  [USAGE_CODES.DOES_NOT_WORK]: 'What is wrong with the new part?',
  [USAGE_CODES.DAMAGED_IN_TRANSIT]: 'What is wrong with the new part?',
  [USAGE_CODES.WRONG_PART]: 'Is a different part needed?',
};

type PartKeys = 'id' | 'externalId'| 'externalNumber' | 'description' | 'returnable' | 'trackingNumber' | 'carrier' | 'carrierOther' | 'returnInstruction';
type UsageKeys = 'usageCode' | 'customerRetained' | 'returnTracking' | 'returnCarrier' | 'returnCarrierOtherName' | 'note';

export type Part = {
    [k in PartKeys]: k extends 'id' ? number : string;
}

export type PartUsage = {
    [k in UsageKeys]: string;
}

export class PartsForm extends React.Component<any, any> {}


export interface PartV1 {
  id?: number;
  external_id: string;
  description: string;
  external_number?: string;
  usage_code?: {
    id?: number;
    name: string;
  };
  note?: string;
  incoming_tracking?: {
    tracking_id: string;
    carrier_name: string;
  };
  return_tracking?: {
    tracking_id: string;
    carrier_name: string;
    not_returned_reason?: string | null;
  };
  return_policy: {
    is_returnable: boolean;
    return_instruction?: string;
  };
}
